const asNonEmptyString = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

const pickFirstString = (...candidates) => {
  for (const candidate of candidates) {
    const value = asNonEmptyString(candidate);
    if (value) return value;
  }
  return "";
};

const asPlainObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value) ? value : null;

const unwrapBookingPayload = (event) => {
  const root = asPlainObject(event) || {};
  const detail = asPlainObject(root.detail);
  const nestedData =
    asPlainObject(root.data) ||
    asPlainObject(detail?.data) ||
    detail ||
    asPlainObject(root.arg);

  return {
    ...root,
    ...(nestedData || {}),
    booking: asPlainObject(nestedData?.booking) || asPlainObject(root.booking),
  };
};

export const parseCalBookingEvent = (event) => {
  const payload = unwrapBookingPayload(event);
  const booking = asPlainObject(payload.booking) || {};

  const startTime = pickFirstString(
    payload.startTime,
    booking.startTime,
    payload.date,
    booking.start,
    booking.date
  );
  const endTime = pickFirstString(payload.endTime, booking.endTime, booking.end);
  const uid = pickFirstString(
    payload.uid,
    booking.uid,
    typeof booking.id === "string" ? booking.id : ""
  );
  const title = pickFirstString(
    payload.title,
    booking.title,
    asPlainObject(payload.eventType)?.title
  );

  if (!startTime) {
    return null;
  }

  return {
    startTime,
    endTime,
    uid,
    title,
  };
};
